export default __webpack_public_path__ + "static/media/undraw_Investing.d67a7429.svg";